
import { get, sync } from 'vuex-pathify'

export default {
  props: {
    buttonText: {
      type: String,
      default: 'orderNow'
    },
    large: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    postalCode(value) {
      this.zipcode = value
      this.city = this.cityName
    }
  },
  data() {
    return {
      postal: null,
    }
  },
  computed: {
    postalCode: sync('delivery/postalCode'),
    zipcode: sync('shoppingCart/address@zipcode'),
    city: sync('shoppingCart/address@city'),
    valid: get('delivery/validPostalCode'),
    cityName: get('delivery/cityName')
  },
  methods: {
    onClick() {
      this.postalCode = this.postal.replace(/\D/g, '')

      if (this.valid) {
        if (!this.$route.name.startsWith(this.$cart.continuePath)) {
          this.$cart.continueShopping()
        }
      }
    },
    onClear() {
      this.postal = null
      this.postalCode = null
    }
  },
  mounted() {
    this.postal = (this.postalCode || '').toString()
  }
}
